export default __webpack_public_path__ + "static/media/shareTw1.3c2a4ed8.png";